import { Component, Input } from "@angular/core";
import { Observable } from "rxjs";
import { AuthorService } from "src/app/inventory/author/author.service";
import { Page } from "src/app/util/page";
import { StringCriteriaSearchComponent } from "src/app/util/search/criteria/string-criteria-search.component";

@Component({
  selector: 'author-search-criteria',
  styleUrls: ['../../../../util/search/criteria/criteria-search.component.css'],
  templateUrl: '../../../../util/search/criteria/criteria-search.component.html'
})
export class AuthorSearchCriteriaComponent extends StringCriteriaSearchComponent {
  @Input()
  public loading!: boolean;
  
  constructor(authorService: AuthorService) {
    super("Auteur", query => authorService.findByNameLike(query));
  }

  formatResultsMetadataLabel(): string {
    return "autheur(s) affiché(s) sur";
  }
}